// ═══════════════════════════════════════════════════════════════
//  workflow.js — qui déclenche la validation en 2 étapes (lot T6)
//
//  ⚠️ CE FICHIER N'IMPORTE RIEN, ET C'EST VOLONTAIRE — même parti pris que
//  affectation.js. La logique vivait dans useTachesModule.js, qui importe
//  React et firebase/firestore : impossible à charger en `node` pur, donc
//  impossible à tester selon la convention du repo. Elle est extraite ici et
//  RÉ-EXPORTÉE par useTachesModule.js : aucun import existant ne change.
// ═══════════════════════════════════════════════════════════════

// Rôles pilotes du workflow 2 étapes. Calque EXACT de la rule
// `estPilote() = isConducteur() || role() == "Chef chantier"`, où
// isConducteur() couvre Admin + Direction + Conducteur travaux.
export const ROLES_PILOTES = ["Admin", "Direction", "Conducteur travaux", "Chef chantier"];

// Rôles EXÉCUTANTS : les seuls dont la présence explicite dans
// `createdByRole` désactive le workflow 2 étapes. Tout le reste — champ
// absent, vide, ou rôle inconnu — l'EXIGE (cf. estWorkflowDeuxEtapes).
export const ROLES_EXECUTANTS = ["Monteur", "Artisan"];

// Déclencheur du workflow 2 étapes (ticket §7) : une tâche CONFIÉE — de
// chantier OU nommément attribuée — dont le créateur n'est pas un exécutant.
// `createdByRole` est un SNAPSHOT figé à la création — un rôle peut changer,
// le workflow d'une tâche déjà ouverte, non.
//
// LOT T7 — `assigneUid` déclenche autant que `chantierId`. Une tâche confiée à
// quelqu'un mérite le même contrôle qu'une tâche de chantier : la personne
// coche, le créateur valide. Et c'est précisément le cas qui n'avait PAS de
// chantier (« Préparer le chantier Rossignol », attribué avant même que le
// chantier existe au référentiel) — le seul lien uid ↔ tâche est alors
// l'assignation. Une chaîne vide, `null`, ou une valeur non-chaîne ne
// déclenchent rien : ce sont des « pas d'assignation », pas des assignations.
//
// 🔴 LE DÉFAUT EST « VALIDATION EXIGÉE », et c'est le cœur du lot T6.
// L'implémentation précédente (`ROLES_PILOTES.includes(createdByRole || "")`)
// faisait l'inverse : un `createdByRole` ABSENT retombait sur la liste des
// pilotes, donc sur `false`, donc PAS de validation. Or le seul client qui
// omet ce champ est la PWA de capture, dont l'unique utilisateur est la
// Direction — donc un pilote : ces tâches-là sont précisément celles qui
// doivent être validées, et elles échappaient toutes au workflow.
// Et l'asymétrie du risque tranche le reste : exiger une validation de trop
// est sans danger (un pilote valide en un clic), sauter une validation due ne
// l'est pas (une tâche de chantier passe « faite » sans que personne ne l'ait
// contrôlée). En cas de doute, on valide.
export function estWorkflowDeuxEtapes(t) {
  const assigneUid = typeof t?.assigneUid === "string" ? t.assigneUid.trim() : "";
  const confiee = !!t?.chantierId || !!assigneUid;
  if (!confiee) return false;
  const role = typeof t?.createdByRole === "string" ? t.createdByRole.trim() : "";
  return !ROLES_EXECUTANTS.includes(role);
}

// T16 — Une tâche que J'AI créée et CONFIÉE à quelqu'un d'autre. Elle n'est plus
// « à faire » pour moi : c'est moi qui la validerai. Assignée à moi-même,
// elle reste une tâche personnelle.
// ⚠️ `uid` = uid Firebase Auth, comparé à `ownerUid` / `assigneUid` (tous deux
// en uid Auth) — jamais un ressourceId.
export function estDelegueeParMoi(tache, uid) {
  if (!tache || !uid) return false;
  if (tache.ownerUid !== uid) return false;
  return !!tache.assigneUid && tache.assigneUid !== uid;
}
